import React from 'react';
import PropTypes from 'prop-types';
import './AddPortfolioPopup.css';

export const AddPortfolioPopup = ({ children }) => (
  <div className="row">{children}</div>
);

AddPortfolioPopup.propTypes = {
  children: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/components/Popup/AddPortfolioPopup/AddPortfolioPopup.js